// Curated lucide icons selectable for a service. Stored as a name string in the
// DB and resolved to a component here — you can't safely dynamic-import
// arbitrary lucide icons, so admins pick from this allowlist. Every icon below
// is already used elsewhere in the app, so it's guaranteed to exist in the
// pinned lucide-react version. Extend this list with any other lucide icon name.
import {
  Plane, Ship, Truck, Warehouse, FileCheck2, Building2,
  Package, Route, ShieldCheck, Globe2, MapPin, Layers,
} from "lucide-react";

export const SERVICE_ICONS = {
  Plane, Ship, Truck, Warehouse, FileCheck2, Building2,
  Package, Route, ShieldCheck, Globe2, MapPin, Layers,
};

export const SERVICE_ICON_NAMES = Object.keys(SERVICE_ICONS);

export function iconFor(name) {
  return SERVICE_ICONS[name] || Package;
}
